externalId:
  en: 'External ID'
  es: 'Num. externo'
  fr: 'ID externe'
  pt: 'ID Externo'
  ru: 'Внешний идентификатор'
priceForOneHour:
  en: 'Cost per hour'
  es: 'Coste por hora'
  fr: 'Coût à l’heure'
  pt: 'Custo por hora'
  ru: 'Стоимость часа'
performerAlertEnable:
  en: 'Alerts for performers'
  es: 'Alertas para conductores'
  fr: 'Alertes pour les opérateurs'
  pt: 'Alertas para conductores'
  ru: 'Напоминание водителю'
signUpSettings:
  en: 'Sign up settings'
  es: 'Registrar ajustes'
  ru: 'Настройки регистрации'
  pt: 'Configurações de inscrição'
startAndEndOfWorkingDay:
  en: 'Start and End of Working Day'
  es: 'Inicio y final del día de trabajo'
  ru: 'Начало и конец рабочего дня'
  pt: 'Início e fim do dia de trabalho'
limitsPerShift:
  en: 'Limits per shift'
  es: 'Límites por turno'
  ru: 'Ограничения смены'
  pt: 'Limites por turno'
availabilityHours:
  en: 'Availability hours'
  es: 'Disponibilidad de horas'
  fr: 'Disponibilité heures'
  pt: 'Horas de disponibilidade'
  ru: 'График работы'
fixedWorkDayStart:
  en: 'Start driving exactly from the shift start'
  es: 'Iniciar ruta a partir de hora del inicio del conductor'
  fr: "Début de conduite exactement après le début d'équipe"
  pt: 'Começar a conduzir exatamente no início do turno'
  ru: 'Выезжать строго в начале смены'
drivingLimit:
  en: 'Driving limit'
  es: 'Límite de conducción'
  fr: 'Limite de conduite'
  pt: 'Limite de condução'
  ru: 'Время вождения'
runTimeLimit:
  en: 'Run duration limit'
  es: 'Duración límite de la ruta'
  fr: 'Temps de tournée limite'
  pt: 'Tempo máximo de rota'
  ru: 'Продолжительность рейса'
alertDriverWillReturnToStartLocation:
  en:
    'The driver has "No (Reload at start)" selected for the start location. If the driver has collections, they will
    return to the start location, not DC.'
  es:
    'El conductor tiene seleccionado "No (Recarga al inicio)" para la ubicación de inicio. Si el conductor tiene
    colecciones, volverán a la ubicación de inicio, no al Deposito.'
  fr:
    'The driver has "No (Reload at start)" selected for the start location. If the driver has collections, they will
    return to the start location, not DC.'
  pt:
    'O condutor tem "Não (Recarregar no início)" seleccionado para o local de partida. Se o condutor tiver colecções,
    voltará ao local de início, e não a DC.'
  ru:
    'У водителя выбрана настройка "Нет (Погрузка в точке начала)". Если у водителя есть заказы типа "сбор", он вернется
    в точку начала дня, а не в РЦ.'
workingLimit:
  en: 'Duty time limit'
  es: 'Límite del tiempo de servicio'
  fr: 'Temps de service limite'
  pt: 'Limite de trabalho diário'
  ru: 'Продолжительность работы'
vehicleHasDriver:
  en:
    'You have selected a vehicle with a driver already assigned to it. What would you like to do with this assigned
    driver?'
  es: 'has seleccionado un vehículo con un conductor ya asignado. ¿Que te gustaría hacer con este conductor asignado?'
  fr:
    'Vous avez sélectionné un véhicule avec un conducteur déjà assigné. Que souhaitez-vous faire avec ce conducteur assigné?'
  pt:
    'Selecionou um veículo que já tem um(a) condutor(a) atribuído(a). O que pretende fazer com o(a)condutor(a) já
    atribuído?'
  ru: 'Вы выбрали машину, на которую назначен водитель. Что вы хотите сделать с водителем?'
swapVehicles:
  en: 'Swap vehicles'
  es: 'Intercambiar vehículos'
  fr: 'Échanger des véhicules'
  pt: 'Trocar veículos'
  ru: 'Сменить машины'
unallocatedDriver:
  en: 'Unallocate driver from that vehicle'
  es: 'Desasignar conductor desde ese vehículo'
  fr: 'Désaffecter le conducteur de ce véhicule'
  pt: 'Anular atribuição do condutor ao veículo'
  ru: 'Освободить водителя от той машины'
breakShift:
  en: 'Allow break shift by'
  ru: 'Разрешить сдвигать перерыв на'
  es: 'Permitir cambio de descanso por'
  fr: 'Autoriser le changement de pause par'
  pt: 'Permitir mudança de pausa por'
scheduleRemoveIfUnavailable:
  en: "This driver's schedule will be removed. Continue?"
  da: 'Brugerens skema vil blive ændret, vil du fortsætte?'
  es: 'La programaciуn del conductor se borrara. ¿Continuamos?'
  fr: 'Le planning de ce chauffeur va etre supprimé. Continuer?'
  pt: 'O planamento deste condutor será removida. Continuar de qualquer modo?'
  ru: 'Расписание этого водителя будет удалено. Продолжить?'
RESOURCE_HAS_SCHEDULE:
  en:
    'The selected driver has orders allocated for the selected day. If you proceed, the orders will be unallocated.
    Would you like to proceed?'
  fr:
    'Le conducteur sélectionné a des commandes attribuées pour le jour sélectionné. Si vous continuez, les commandes
    seront désattribuées. Souhaitez-vous continuer?'
  ru: 'На выбранного водителя запланированы заказы. Эти заказы будут отпланированы. Продолжить?'
  es:
    'El conductor seleccionado tiene pedidos asignados para el día seleccionado. Si continúa, los pedidos se
    desasignarán. ¿Le gustaría continuar?'
  pt:
     'O condutor selecionado tem pedidos atribuídos para o dia selecionado. Se prosseguir, a atribuição dos pedidos será
    cancelada. Deseja continuar?'
RESOURCE_HAS_SCHEDULE_WITH_DATE:
  en:
    'The selected driver has orders allocated for the following day: {0}. If you proceed, the orders will be
    unallocated. Would you like to proceed? '
  fr:
    'Le conducteur sélectionné a des commandes attribuées pour le jour suivant : {0}. Si vous continuez, les
    commandes seront désattribuées. Souhaitez-vous continuer ?'
  ru: 'На выбранного водителя запланированы заказы на следующую дату: {0}. Эти заказы будут отпланированы. Продолжить?'
  es:
    'El conductor seleccionado tiene pedidos asignados para el día siguiente: {0}. Si continúa, los pedidos serán
    desasignados. ¿Le gustaría continuar?'
  pt:
    'O condutor selecionado tem pedidos atribuídos para o dia seguinte: {0}. Se prosseguir, a atribuição dos pedidos
    será cancelada. Deseja continuar?'
RESOURCE_HAS_SCHEDULE_WITH_DATES:
  en:
    'The selected driver has orders allocated for the following days: {0}. If you proceed, the orders will be
    unallocated. Would you like to proceed? '
  fr:
    'Le conducteur sélectionné a des commandes attribuées pour les jours suivants : {0}. Si vous continuez, les
    commandes seront désattribuées. Souhaitez-vous continuer ?'
  ru: 'На выбранного водителя запланированы заказы на следующие даты: {0}. Эти заказы будут отпланированы. Продолжить?'
  es:
    'El conductor seleccionado tiene pedidos asignados para los días siguientes: {0}. Si continúa, los pedidos serán
    desasignados. ¿Le gustaría continuar?'
  pt:
    'O condutor selecionado tem pedidos atribuídos para os dias seguintes: {0}. Se prosseguir, a atribuição dos pedidos
    será cancelada. Deseja continuar?'
newDriver:
  en: new
  es: nuevo
  fr: nouveau
  pt: novo
  ru: новый
addingNewDriver:
  en: 'Adding new driver'
  es: 'Añadiendo nuevo conductor'
  fr: 'Ajout d’un nouveau conducteur'
  pt: 'Adicionando novo condutor'
  ru: 'Добавление нового водителя'
loginInfo:
  en: Login info
  es: Información de inicio de sesión
  fr: Informations de connexion
  pt: Informações de login
  ru: Информация для входа
basics: 
  en: 'Basics'
  es: 'Básicos'
  fr: 'Basiques'
  pt: 'Básicos'
  ru: 'Основные'
operatingHours: 
  en: 'Operating hours'
  es: 'Horas de operación'
  fr: 'Heures de fonctionnement'
  pt: 'Horas de operação'
  ru: 'Часы работы'
execution: 
  en: 'Execution'
  es: 'Ejecución'
  fr: 'Exécution'
  pt: 'Execução'
  ru: 'Выполнение'
cloneDriver:
  en: 'Clone driver'
  es: 'Clonar conductor'
  fr: 'Cloner le conducteur'
  pt: 'Clonar condutor'
  ru: 'Клонировать водителя'
  